//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "GXInfoQuery",
};
